import { FC } from 'react';
import clsx from 'clsx';
import { useMergedStyles } from 'hooks/useMergedStyles';
import { Styles } from 'types/styles';

import styles from './LabelBoxWrapper.module.scss';

type Props = {
  newStyles?: Styles;
  hide?: boolean;
  additionalClass?: string;
  showLabel?: boolean;
  label?: string;
  isActive?: boolean;
};
const LabelBoxWrapper: FC<Props> = ({
  newStyles = {},
  label = '',
  hide = false,
  showLabel = true,
  additionalClass = '',
  isActive = false,
  children,
}) => {
  const mergedStyles = useMergedStyles(styles, newStyles);

  if (hide) return <>{children}</>;

  return (
    <div
      className={clsx(mergedStyles['label-box-wrapper'], {
        [additionalClass]: additionalClass,
        [mergedStyles['label-box-isActive']]: isActive,
      })}
      data-cy="label-box"
    >
      {showLabel && (
        <div
          className={clsx(mergedStyles['label-box-label'], {
            [mergedStyles['label-box-isActive']]: isActive,
          })}
        >
          {label}
        </div>
      )}
      {children}
    </div>
  );
};

export default LabelBoxWrapper;
